export default __webpack_public_path__ + "static/media/monetization.f348998b.svg";